import axios from 'axios';

export default {
  install: (app, options = {
    key: "6LeGb3wqAAAAAA-UFOu1o1f1wjHTBj8vFFhALYMT",
    hide: false
  }) => {

    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/enterprise.js?render=${options.key}`);
    document.head.appendChild(recaptchaScript);

    // if (options.hide) {
    //   setTimeout(() => {
    //     const el = document.querySelector(".grecaptcha-badge");
    //     el.style.display = 'none';
    //   }, 2000);
    // }

    const execute = () => {
      return new Promise((resolve, reject) => {
        grecaptcha.enterprise.execute(options.key, { action: 'USER_ACTION' })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error);
          });
      })
    };

    const verify = (token, verifyUrl) => {
      // const request = {
      //   "event": {
      //     "token": token,
      //     "expectedAction": "USER_ACTION",
      //     "siteKey": options.key,
      //   }
      // }

      const request = {
        "recaptchaKey": options.key,
        "token": token,
        "project": "freshdesign-websites",
        "action": "USER_ACTION",
      }

      return new Promise((resolve, reject) => {
        axios.post(verifyUrl, request, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": window.Laravel.csrfToken,
          }
        })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      })
    };

    const executeAndVerify = async (verifyUrl) => {
      const token = await execute();
      return await verify(token, verifyUrl);
    }

    const recaptcha = { execute, verify, executeAndVerify };

    app.config.globalProperties.$recaptcha = recaptcha;
    app.provide('$recaptcha', recaptcha);
  }
}